import { Compass } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * The page someone lands on when a URL does not exist.
 *
 * It deliberately says nothing about what the system is made of. The earlier
 * version announced which build phase a screen belonged to, which is internal
 * roadmap detail — useful to us, and free reconnaissance for anyone else.
 */
export function ComingSoon({ title, what }: { title: string; what: string }) {
  return (
    <div className="mx-auto max-w-xl py-16 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-50">
        <Compass className="h-7 w-7 text-primary-500" aria-hidden="true" />
      </div>
      <h2 className="mt-5 font-heading text-2xl">{title}</h2>
      <p className="mt-2 text-muted-foreground">{what}</p>
      <Link to="/" className="btn-secondary mt-6">
        Back to the board
      </Link>
    </div>
  );
}
